import API from '../';
import { HTTP_METHODS } from '../helpers/methods-helpers';

class NotificationsReAPI extends API {
	createNotification(data) {
		const dataString = JSON.stringify(data);
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}`,
				data: dataString,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getNotifications(unit, user, pagination, currentPage) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/filtros?unidadAdministrativa=${unit}&usuario=${user}&sigPagina=${currentPage}&paginacion=${pagination}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getNotification(id) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/consulta_detalle/${id}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	resendNotification(id) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/reenvio/${id}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}
}

export const notificationsReAPI = new NotificationsReAPI('/notificacion_resolucion');
